module.exports = __webpack_public_path__ + "static/media/New Zealand.b0937282.png";